export default __webpack_public_path__ + "static/media/yearlyLychee.8006e9de.svg";